import { useIntl } from 'react-intl'
import { AzPageHeader } from '../../../components/AzPageHeader'
import Promotions from '../tour-details/tabs/PricingTab/components/Promotions'

const TourPromotionsPage = () => {
  const intl = useIntl()

  return (
    <>
      <AzPageHeader title={intl.formatMessage({ id: 'TOUR.PROMOTIONS.TITLE' })} />
      <div className='card card-flush mx-0 mx-md-10 mb-10'>
        <div className='card-body'>
          <Promotions intl={intl} showAllTours />
        </div>
      </div>
    </>
  )
}

export default TourPromotionsPage
